import { render, staticRenderFns } from "./StatusRadio.vue?vue&type=template&id=06d019d1&scoped=true&lang=pug"
import script from "./StatusRadio.vue?vue&type=script&lang=ts"
export * from "./StatusRadio.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d019d1",
  null
  
)

export default component.exports